import React from 'react';
import { 
  BrowserRouter as Router, 
  Route, 
  Switch,
  Redirect } from 'react-router-dom';

import Home from './pages/home.page';
import DeactivationRequest from './components/deactivation-request/deactivation-request.component';
import ErrorMessage from './components/error/error.component';
// import Footer from './components/footer/footer.component';

import './App.css';
import deactivator from './deactivator.png';

const App = () => {
  return (
    <div className="App">
      <header className="App-header" >
        <img src={deactivator} className="App-logo" alt="deactivator-logo" />
      </header>
      <Router>
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/request/:messageId"> 
            <DeactivationRequest />
          </Route>
          <Route exact path="/request/programmatic/:messageId">
            <DeactivationRequest programmatic />
          </Route>
          <Route exact path="/error" component={ErrorMessage} />
          <Route path="*"><Redirect to="/" /></Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
